var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button, InputTextarea, Typography } from "@uigovpe/components";
import { useCallback, useEffect, useMemo, useState, } from "react";
import { useNavigate } from "react-router-dom";
import { getApiErrorMessage } from "../../../apis/http";
import { createHearingComment, createHearingSupport, deleteHearingComment, deleteHearingSupport, listHearingComments, updateHearingComment, } from "../../../apis/hearingParticipation";
import { useAuth } from "../../auth/AuthContext";
import { CommentsThread } from "../../consultations/components/CommentsThread";
import { goToOrLogin } from "../utils/authNavigate";
import { buildSupportsMapFromComments, clearPersistedHearingSupport, loadStoredHearingSupports, mergeHearingUserSupports, persistHearingSupport, } from "../utils/hearingCommentSupports";
import { canContributeToHearing } from "../utils/participation";
var noteBoxStyle = {
    background: "#E6F3FF",
    borderRadius: 12,
    display: "grid",
    gap: 8,
    marginBottom: 24,
    padding: 16,
};
var contentBlockStyle = {
    display: "grid",
    gap: 16,
};
var mapHearingCommentToNode = function (comment) {
    var _a;
    return ({
        id: comment.id,
        consultationId: comment.publicHearingId,
        userId: comment.userId,
        content: comment.content,
        parentCommentId: (_a = comment.parentCommentId) !== null && _a !== void 0 ? _a : undefined,
        supportCount: comment.supportCount,
        childrenComments: (comment.childrenComments || []).map(mapHearingCommentToNode),
        user: comment.user
            ? {
                id: comment.user.id,
                name: comment.user.name,
                role: comment.user.role || "citizen",
                email: comment.user.email || "",
            }
            : null,
        createdAt: comment.createdAt,
        updatedAt: comment.updatedAt,
    });
};
export var HearingCommentsSection = function (_a) {
    var hearingId = _a.hearingId, hearingStatus = _a.hearingStatus, _b = _a.showDisclaimer, showDisclaimer = _b === void 0 ? true : _b;
    var navigate = useNavigate();
    var _c = useAuth(), accessToken = _c.accessToken, hasPortalConnect = _c.hasPortalConnect, hasToken = _c.hasToken, isAuthenticated = _c.isAuthenticated, login = _c.login, role = _c.role, user = _c.user;
    var _d = useState([]), comments = _d[0], setComments = _d[1];
    var _e = useState(""), commentValue = _e[0], setCommentValue = _e[1];
    var _f = useState(true), loading = _f[0], setLoading = _f[1];
    var _g = useState(false), sending = _g[0], setSending = _g[1];
    var _h = useState(null), error = _h[0], setError = _h[1];
    var _j = useState({}), supportOverrides = _j[0], setSupportOverrides = _j[1];
    var canComment = canContributeToHearing(hearingStatus);
    var canShowInput = canComment && (hasToken || isAuthenticated);
    var loadComments = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, nextComments, fromApi, loadError_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    setError(null);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, listHearingComments(hearingId, accessToken)];
                case 2:
                    response = _a.sent();
                    nextComments = response.data.comments || [];
                    setComments(nextComments);
                    if (user === null || user === void 0 ? void 0 : user.id) {
                        fromApi = buildSupportsMapFromComments(nextComments);
                        Object.entries(fromApi).forEach(function (_a) {
                            var commentId = _a[0], supportId = _a[1];
                            persistHearingSupport(user.id, hearingId, Number(commentId), supportId);
                        });
                    }
                    return [3 /*break*/, 5];
                case 3:
                    loadError_1 = _a.sent();
                    setError(getApiErrorMessage(loadError_1));
                    setComments([]);
                    return [3 /*break*/, 5];
                case 4:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [accessToken, hearingId, user === null || user === void 0 ? void 0 : user.id]);
    useEffect(function () {
        void loadComments();
    }, [loadComments]);
    var commentNodes = useMemo(function () { return comments.map(mapHearingCommentToNode); }, [comments]);
    var baseUserSupports = useMemo(function () {
        var fromApi = buildSupportsMapFromComments(comments);
        if (!(user === null || user === void 0 ? void 0 : user.id)) {
            return fromApi;
        }
        return __assign(__assign({}, loadStoredHearingSupports(user.id, hearingId, comments)), fromApi);
    }, [comments, hearingId, user === null || user === void 0 ? void 0 : user.id]);
    var userSupports = useMemo(function () { return mergeHearingUserSupports(baseUserSupports, supportOverrides); }, [baseUserSupports, supportOverrides]);
    var requireAuth = function () {
        goToOrLogin({
            hasPortalConnect: hasPortalConnect,
            hasToken: hasToken,
            isAuthenticated: isAuthenticated,
            login: login,
            navigate: navigate,
            path: "/hearings/details/".concat(hearingId),
        });
    };
    var handleSendRootComment = function () { return __awaiter(void 0, void 0, void 0, function () {
        var sendError_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!commentValue.trim()) {
                        return [2 /*return*/];
                    }
                    if (!accessToken) {
                        requireAuth();
                        return [2 /*return*/];
                    }
                    setSending(true);
                    setError(null);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, 5, 6]);
                    return [4 /*yield*/, createHearingComment(hearingId, { content: commentValue.trim() }, accessToken)];
                case 2:
                    _a.sent();
                    setCommentValue("");
                    return [4 /*yield*/, loadComments()];
                case 3:
                    _a.sent();
                    return [3 /*break*/, 6];
                case 4:
                    sendError_1 = _a.sent();
                    setError(getApiErrorMessage(sendError_1));
                    return [3 /*break*/, 6];
                case 5:
                    setSending(false);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var handleSubmitReply = function (parentId, content) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!accessToken) {
                        requireAuth();
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, createHearingComment(hearingId, { content: content, parentCommentId: parentId }, accessToken)];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, loadComments()];
                case 2:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var handleUpdateComment = function (commentId, content) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!accessToken) {
                        requireAuth();
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, updateHearingComment(hearingId, commentId, { content: content }, accessToken)];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, loadComments()];
                case 2:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var handleDeleteComment = function (commentId) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!accessToken) {
                        requireAuth();
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, deleteHearingComment(hearingId, commentId, accessToken)];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, loadComments()];
                case 2:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var handleAddSupport = function (commentId) { return __awaiter(void 0, void 0, void 0, function () {
        var response, supportId;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!accessToken) {
                        requireAuth();
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, createHearingSupport(hearingId, commentId, accessToken)];
                case 1:
                    response = _a.sent();
                    supportId = response.data.support.id;
                    if (user === null || user === void 0 ? void 0 : user.id) {
                        persistHearingSupport(user.id, hearingId, commentId, supportId);
                    }
                    setSupportOverrides(function (current) {
                        var _a;
                        return (__assign(__assign({}, current), (_a = {}, _a[commentId] = supportId, _a)));
                    });
                    return [4 /*yield*/, loadComments()];
                case 2:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var handleRemoveSupport = function (commentId, supportId) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!accessToken) {
                        requireAuth();
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, deleteHearingSupport(hearingId, commentId, supportId, accessToken)];
                case 1:
                    _a.sent();
                    if (user === null || user === void 0 ? void 0 : user.id) {
                        clearPersistedHearingSupport(user.id, hearingId, commentId);
                    }
                    setSupportOverrides(function (current) {
                        var _a;
                        return (__assign(__assign({}, current), (_a = {}, _a[commentId] = null, _a)));
                    });
                    return [4 /*yield*/, loadComments()];
                case 2:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs(_Fragment, { children: [showDisclaimer ? (_jsxs("div", __assign({ style: noteBoxStyle }, { children: [_jsx(Typography, __assign({ fontWeight: "bold", size: "sm" }, { children: "Obs.:" })), _jsx(Typography, __assign({ size: "sm" }, { children: "Os coment\u00E1rios s\u00E3o um espa\u00E7o para di\u00E1logo e troca de opini\u00F5es entre os cidad\u00E3os. Eles n\u00E3o s\u00E3o considerados contribui\u00E7\u00F5es oficiais e n\u00E3o entram na an\u00E1lise dos resultados da audi\u00EAncia." })), _jsx(Typography, __assign({ size: "sm" }, { children: "Para que sua participa\u00E7\u00E3o seja registrada como inscri\u00E7\u00E3o/contribui\u00E7\u00E3o, \u00E9 necess\u00E1rio responder ao formul\u00E1rio ou enviar a contribui\u00E7\u00E3o aberta da audi\u00EAncia. Somente essas respostas s\u00E3o contabilizadas." }))] }))) : null, _jsxs("div", __assign({ style: contentBlockStyle }, { children: [canShowInput ? (_jsxs("div", __assign({ style: { display: "grid", gap: 16 } }, { children: [_jsx(InputTextarea, { label: "Deixe um coment\u00E1rio", onChange: function (event) {
                                    return setCommentValue(event.target.value);
                                }, placeholder: "Digite", rows: 6, value: commentValue }), _jsxs("div", __assign({ style: {
                                    display: "flex",
                                    gap: 16,
                                    justifyContent: "flex-end",
                                } }, { children: [_jsx(Button, { label: "Cancelar", link: true, onClick: function () { return setCommentValue(""); }, size: "small" }), _jsx(Button, { disabled: sending || !commentValue.trim(), label: sending ? "Enviando..." : "Enviar", onClick: function () { return void handleSendRootComment(); }, size: "small" })] }))] }))) : canComment ? (_jsx(Button, { label: "Fa\u00E7a login para comentar", onClick: requireAuth, severity: "secondary" })) : null, error ? (_jsx(Typography, __assign({ size: "sm", style: { color: "#7A1F1F" } }, { children: error }))) : null, loading ? (_jsx(Typography, { children: "Carregando coment\u00E1rios..." })) : (_jsx(CommentsThread, { comments: commentNodes, currentUserId: user === null || user === void 0 ? void 0 : user.id, currentUserRole: role, emptyMessage: "Nenhum coment\u00E1rio publicado ainda.", onAddSupport: canComment ? handleAddSupport : undefined, onDeleteComment: canComment ? handleDeleteComment : undefined, onRemoveSupport: canComment ? handleRemoveSupport : undefined, onSubmitReply: canComment ? handleSubmitReply : undefined, onUpdateComment: canComment ? handleUpdateComment : undefined, userSupports: userSupports }))] }))] }));
};
